import React, { useState } from 'react';
import { CCollapse, CCard, CCardBody, CButton } from '@coreui/react';
import '../css/AshadL.css';
import m1 from '../images/m1.png';
import m2 from '../images/m2.png';
import m3 from '../images/m3.png';
import m4 from '../images/m4.png';
import m5 from '../images/m5.png';
import m6 from '../images/m6.png';
import m7 from '../images/m7.png';


const AshadL = () => {
    const [visible1, setVisible1] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [visible3, setVisible3] = useState(false);
    const [visible4, setVisible4] = useState(false);
    const [visible5, setVisible5] = useState(false);

    const toggleCard = (index) => {
        switch (index) {
            case 1:
                setVisible1(!visible1);
                break;
            case 2:
                setVisible2(!visible2);
                break;
            case 3:
                setVisible3(!visible3);
                break;
            case 4:
                setVisible4(!visible4);
                break;
            case 5:
                setVisible5(!visible5);
                break;
            default:
                break;
        }
    };

    return (
        <div className="ashad-container">
            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(1);
            }}>
             A Storytelling Robot Managing Persuasive and Ethical Stances via ACT-R: An Exploratory Study
            </a>
            <br />
            <CCollapse visible={visible1}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>"A Storytelling Robot Managing Persuasive and Ethical Stances via ACT-R: An Exploratory Study"</h5>
      
    
        <p> <b>Authors:</b> Agnese Augello, Giuseppe Città, Manuel Gentile, and Antonio Lieto</p>

      <h6>Introduction:</h6>
      <p>
        This research explores the use of an artificial agent powered by the ACT-R cognitive architecture to engage users in conversations. The primary focus is on employing persuasive and ethical strategies through a storytelling approach. The study assessed the effectiveness of these strategies in changing user attitudes, particularly related to COVID-19 rules and vaccines. The findings indicate that narrative strategies, combined with ethical stances, can effectively persuade users to re-evaluate their beliefs. The paper also examines the impact of specific persuasive techniques, highlighting the effectiveness of framing and ad verecundiam, while argumentum ad populum showed limited impact. The study outlines future research directions, emphasizing the need to test the model on physical robot platforms and explore ethical considerations in persuasive technologies. Overall, the research demonstrates the potential of artificial agents to influence user attitudes and behaviors on critical public health issues.
      </p>

      <h6>Methodology:</h6>
      <p>
        The study employs a virtual robot, InfoRob, to interact with users through an online platform. The robot uses the ACT-R cognitive architecture and a WebSocket communication middleware. Users are presented with a variety of dialogues that address different topics related to COVID-19 rules and vaccines.
      </p>

      <h6>Results:</h6>
      <p>
        Several key findings emerged from the study:
        - Narrative strategies, coupled with ethical stances, effectively persuaded users to re-evaluate their beliefs and attitudes.
        - The use of persuasive techniques, such as framing and ad verecundiam, had a positive impact on user agreement with presented statements.
        - Argumentum ad populum was found to be less effective as a persuasive technique.
        - Users generally expressed satisfaction with the interaction with the robot-avatar.
      </p>

      <h6>Future Directions:</h6>
      <p>
        The paper outlines future research directions, including:
        - Testing the model on physical robot platforms to leverage embodied features.
        - Expanding the sample of participants and increasing the variety of topics for more comprehensive data.
        - Exploring ethical considerations in the use of persuasive technologies.
      </p>

      <h6>Conclusion:</h6>
      <p>
        The study demonstrates the potential of artificial agents, driven by the ACT-R cognitive architecture, to influence user attitudes and behaviors, especially on critical public health issues. The combination of persuasive techniques, ethical stances, and storytelling strategies can lead to significant changes in user beliefs, highlighting the importance of ethical considerations in persuasive technologies.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(1)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(2);
            }}>
                A Survey on Storytelling with Robots
            </a>
            <br />
            <CCollapse visible={visible2}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: A Survey on Storytelling with Robots</h5>
      <h6>Authors: Gwo-Dong Chen, Nurkhamid, and Chin-Yeh Wang</h6>

      <h6>1. Introduction:</h6>
      <p>
        The introduction highlights the potential of robots for engaging, motivating, and enhancing creativity and literacy, especially in children. It discusses the categorization of educational robots into three types: learning materials, learning companions/pets, and teaching assistants. The paper also mentions that storytelling can be a part of the tasks performed by educational robots.
      </p>

      <h6>2. Storytelling in Human Culture:</h6>
      <p>
        The paper emphasizes the importance of storytelling in human culture as a means of preserving culture, history, and educating learners. With the advent of new technologies, storytelling has evolved to include digital media and, in the case of robots, physical environments.
      </p>

      <h6>3. Categorization:</h6>
      <p>
        The paper categorizes the works on storytelling with robots into four sub-sections:
        - Types of Robots/Machines Used: It lists various robots or robot kits used in the studies, including Handyboard, LEGO Mindstorms, Robosapien V2, Pleo, and custom-made robots.
        - Users: The primary users of these storytelling robots are children, with a focus on both typically developing children and those with disabilities. Some studies also involve teachers as users.
        - Focus of Study: The focus of the studies includes using robots as learning companions/pets, robot programming, design techniques, technology introduction, and pedagogy. Additionally, some studies explore robots as teaching assistants.
        - Outcome: The outcomes of the studies include design and pedagogical experiences, the creation of prototypes, authoring environments for storytelling, learning environments, and mixed physical and digital environments.
      </p>

      <h6>4. Notable Works:</h6>
      <p>
        The paper briefly highlights some notable works in the field, such as the PETS system designed for elementary-school-age children, a robot programmable for storytelling tasks, and a mixed physical and digital authoring environment for children.
      </p>

      <h6>5. Conclusion:</h6>
      <p>
        The paper concludes by noting that most of the research in storytelling with robots is still in its early stages, with promising possibilities for future research. It emphasizes the potential variations in how robots can be used in storytelling contexts and the creation of mixed reality environments for children's storytelling.
      </p>

      <p>
        The paper provides valuable insights into the use of robots for storytelling, especially in educational contexts, and highlights the various ways in which robots can engage with users, particularly children, to enhance their storytelling experiences.
      </p>
    </div>
           <CButton color="danger" onClick={() => toggleCard(2)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(3);
            }}>
                Collaborative Storytelling With Robots: A System for Co-Creating Stories
            </a>
            <br />
            <CCollapse visible={visible3}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: Collaborative Storytelling With Robots: A System for Co-Creating Stories</h5>
      <h6>Authors: Ethan Nichols, Liam Guldner, Yair Vasilyev, Richard Goodwin</h6>

      <h6>Summary:</h6>
      <p>
        "Collaborative Storytelling With Robots: A System for Co-Creating Stories" introduces an innovative concept of collaborative storytelling, where humans and artificial intelligence agents or robots work together to co-create unique and engaging stories. This research paper discusses a collaborative storytelling system that leverages cutting-edge technology to facilitate this interactive narrative generation.
      </p>

      <p>
        The paper begins by highlighting the significance of storytelling in human socialization and entertainment and notes that recent research has focused on conducting storytelling with robots. However, much of this research has traditionally assumed that story content is pre-curated, overlooking the potential for co-creating stories through human-machine collaboration.
      </p>

      <h6>Core Components of the System:</h6>
      <p>
        The core components of the collaborative storytelling system are detailed, offering a comprehensive understanding of how it operates. The system integrates a large-scale language model, fine-tuned on a dataset comprising writing prompts and short stories. This language model serves as the foundation for generating story content. To enhance storytelling quality, the authors introduce a "ranker" component that selects the most suitable output from the language model. Additionally, the paper highlights optimizations to strike a balance between quality and computational cost, ensuring that the system is both efficient and effective.
      </p>

      <h6>Evaluation and Survey:</h6>
      <p>
        To gauge the performance and viability of the collaborative storytelling system, the authors conducted a rigorous evaluation. They recruited human participants to engage in a collaborative storytelling game, comparing the stories co-created with the system to a basic, untuned baseline. The results of this evaluation shed light on how well the system works in practice and how it fares against conventional story generation methods. Importantly, this research provides insights into the capabilities and potential limitations of the system when integrated into human-robot interactions.
      </p>

      <p>
        Furthermore, the paper includes a comprehensive elicitation survey conducted with university students, offering valuable insights into adapting the collaborative storytelling system for social robots. The survey findings indicate a strong preference for social robots that possess rich emotive capabilities, highlighting the importance of emotional expression in human-robot collaborative storytelling. The survey also explores potential target demographics for this application, with children emerging as a popular choice.
      </p>

      <h6>Sentiment Steering in Story Generation:</h6>
      <p>
        One notable aspect of the paper is its exploration of sentiment steering in story generation. The authors demonstrate how sentiment steering can influence the mood and sentiment of generated stories, enhancing user control over the narrative's emotional content. The sentiment steering approach presented in this paper allows for a broader range of story moods and genres, effectively customizing the storytelling experience to the preferences of the participants.
      </p>

      <h6>Conclusion:</h6>
      <p>
        In conclusion, "Collaborative Storytelling With Robots" represents a significant advancement in the field of human-robot interaction. It introduces the innovative concept of collaborative storytelling and presents a comprehensive system that empowers humans to co-create stories with artificial intelligence agents or robots. By focusing on key components such as a fine-tuned language model, a ranker, and sentiment steering, the authors offer a compelling framework for interactive storytelling. The evaluation results and elicitation survey findings demonstrate the potential for this system in human-robot collaboration and highlight the importance of emotive capabilities and emotional expression. This paper provides a strong foundation for future work in the field of collaborative storytelling, with implications for social robots, education, entertainment, and beyond.
      </p>
    </div>
                    
                        <CButton color="danger" onClick={() => toggleCard(3)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(4);
            }}>
                Emotional Storytelling Using Virtual and Robotic Agents
            </a>
            <br />
            <CCollapse visible={visible4}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Title: Emotional Storytelling Using Virtual and Robotic Agents</h5>
      <h6>Authors: S. Costa, I. Tavares, J. Soares, R. Novais, P. Novais, and J. Dias</h6>

      <h6>Summary:</h6>
      <p>
        The paper, titled "Emotional Storytelling Using Virtual and Robotic Agents," authored by S. Costa, I. Tavares, J. Soares, R. Novais, P. Novais, and J. Dias, investigates the role of virtual and robotic agents in emotional storytelling and explores various aspects of the storytelling process, including embodiment, voice, and the emotional connections between storytellers and listeners. The study is composed of two essential experiments and offers valuable insights into creating emotionally engaging storytelling agents.
      </p>

      <h6>Main Research Questions and Findings:</h6>

      <h6>Research Question 1 (RQ1): Is a physically embodied agent preferable to a virtual agent or a voice-only narration for emotional storytelling?</h6>
      <p>
        Findings for RQ1:
        - The study reveals that a physically embodied robot (Aesop) is more effective in capturing and retaining the listener's narrative attention when compared to a virtual embodiment (Greta).
        - It supports this finding with observations of non-verbal body language, such as blinking and hand/arm gestures, which show that the physical robot engages the listener more effectively.
      </p>

      <h6>Research Question 2 (RQ2): Does a human voice have an advantage over a synthesized voice for emotional storytelling?</h6>
      <p>
        Findings for RQ2:
        - The study indicates that a human voice outperforms text-to-speech synthesis (TTS) in emotional storytelling. The human voice is found to be more successful in eliciting emotions in the listener.
        - Observations of facial expressions and non-verbal gestures, including head and arm movements, underscore the effectiveness of the human voice in emotional storytelling.
      </p>

      <h6>Research Question 3 (RQ3): How are emotions displayed by the listener related to the emotions expressed by the story characters and the storyteller during storytelling?</h6>
      <p>
        Findings for RQ3:
        - The study identifies empathy between the storyteller and the listener. This is demonstrated by the alignment of emotional valence between the narrator's facial expressions and the listener's facial expressions over time.
        - The study introduces the concept of emotional "melodies" and "harmonies" in storytelling, suggesting complex relationships between the emotional trajectories of story characters, the storyteller, and the listener.
      </p>

      <h6>Implications and Future Directions:</h6>
      <p>
        The research provides critical insights into the development of emotionally adaptive storytelling agents. It highlights the significance of considering embodiment and voice choices in designing these agents. The paper also touches on the potential for a formal theory that describes the emotional "melodies" and "harmonies" that occur during storytelling.
      </p>

      <p>
        The authors propose several future research directions, such as expanding the study to include a diverse range of stories, varying the level of anthropomorphism in storytelling agents, and exploring the relationship between musical concepts and emotional trajectories in narratives. These avenues of research promise to further enhance our understanding of emotional storytelling and contribute to the development of advanced storytelling agents capable of real-time adaptation based on listener feedback.
      </p>

      <h6>In summary, "Emotional Storytelling Using Virtual and Robotic Agents" sheds light on the art of storytelling with virtual and robotic agents, underlining the role of embodiment, voice, and emotional connections in the process. The findings open the door to new possibilities in creating engaging and emotionally resonant storytelling experiences.</h6>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(4)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>

            <a className="ashad-link" href="#" onClick={(event) => {
                event.preventDefault();
                toggleCard(5);
            }}>
                Storytelling with a Social Robot
            </a>
            <br />
            <CCollapse visible={visible5}>
                <CCard className="ashad-card mt-3">
                    <CCardBody>
                    <div className="content-left">
      <h5>Storytelling with a Social Robot</h5>
      <h6>Authors: Nicole Goossens, Rian Aarts, and Paul Vogt</h6>

      <h6>Background:</h6>
      <p>
        The study takes place in the context of language education, where technology has been increasingly used. Social robots are introduced as potential tools for language learning because they can provide social interactions that are essential for language learning.
      </p>

      <h6>Voice in Social Robots:</h6>
      <p>
        The study notes that many social robots use synthetic text-to-speech (TTS) voices, which may lack prosodic cues important for language learning. Young children are particularly sensitive to prosodic cues such as pitch and intonation when comprehending spoken language.
      </p>

      <h6>Research Goals:</h6>
      <p>
        The primary aim of the study is to investigate the influence of the expressiveness and linguistic complexity of a robot's speech on children's language production and engagement.
      </p>

      <h6>Methodology:</h6>
      <p>
        The study involves reading sessions where children interact with a robot that tells stories from picture books. The robot's speech can be either expressive or inexpressive, and the linguistic complexity of the stories increases with each session.
      </p>

      <h6>Results:</h6>
      <p>
        The study found no significant differences in language production or engagement between the two voice conditions (expressive and inexpressive). However, there was a significant effect of story complexity on the Mean Length of Utterance (MLU) metric, with MLU being lower in the second reading session, which featured a wordless picture book. Engagement remained consistent throughout the sessions, regardless of voice condition or story complexity.
      </p>

      <h6>Discussion:</h6>
      <p>
        The findings suggest that storytelling with social robots can be an effective way for children to practice their oral skills in a second language and to maintain engagement with the robot. The study acknowledges that further research is needed to explore the effects of linguistic and emotional aspects of robot speech on child-robot interactions.
      </p>

      <h6>References:</h6>
      <p>
        The paper includes a list of references that inform the background and related work on social robots in language education and human-robot interactions.
      </p>

      <p>
        The study contributes to the growing field of research on the use of social robots in education, particularly in the context of language learning. It provides insights into the potential benefits and limitations of using social robots for storytelling and language education, with a focus on the expressiveness and complexity of robot speech.
      </p>
    </div>
                        <CButton color="danger" onClick={() => toggleCard(5)}>
                            Close
                        </CButton>
                    </CCardBody>
                </CCard>
            </CCollapse>
        </div>
    );
};

export default AshadL;
